module.exports = __webpack_public_path__ + "img/login.9f86eed3.jpg";